<template>
    <VanPopup
        style="background: transparent"
        :value="value"
        :close-on-click-overlay="false">
        <div class="field-box">
            <div class="field_title van-hairline--bottom">擅长领域</div>
            <div class="field_list">
                <div v-for="(item, index) in list" :key="index" class="field_item">{{item[`${keyword}`]}}</div>
            </div>
            <div class="field_modal"></div>
        </div>
        <div class="close-box">
            <img class="close_btn" @click="$emit('input', false)" src="./img/close.png" alt="">
        </div>
    </VanPopup>
</template>

<script>
    import {Popup as VanPopup, Button as VanButton} from 'vant'

    export default {
        name: 'MoreFields',
        props: {
            value: Boolean,
            list: Array,
            keyword: {
                type: String,
                default: 'specialtyName'
            }
        },
        data() {
            return {
                show: true
            }
        },
        components: {VanPopup, VanButton}
    }
</script>

<style lang="scss" scoped>
    .field-box {
        position: relative;
        width: 320px;
        background: rgba(252, 252, 252, 1);
        overflow: hidden;
        border-radius: 6px;

        .field_title {
            padding: 16px 0;
            font-size: 18px;
            font-weight: 500;
            color: rgba(34, 34, 34, 1);
            text-align: center;
        }

        .field_list {
            padding-top: 14px;
            padding-bottom: 40px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            height: 230px;
            overflow: auto;

            .field_item {
                padding: 10px 12px;
                line-height: 25px;
                background: rgba(252, 233, 230, 1);
                border-radius: 2px;
                margin-bottom: 14px;
                margin-left: 16px;
            }
        }

        .field_modal {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 60px;
            background: url("./img/dialog.png") no-repeat;
            background-size: cover;
        }
    }


    .close-box {
        text-align: center;
        padding-top: 36px;

        .close_btn {
            display: inline-block;
            width: 36px;
        }
    }
</style>
